import React, { useEffect } from "react";
import { Box, CircularProgress } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { fetchUserProfileFromFirestore } from "../../../services/profileService";
import { normalizePublicHandle, getPublicHandle } from "../../../utils/publicProfile";

export default function ProfileUidRedirectPage() {
  const { uid } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let isActive = true;

    async function resolveProfile() {
      const profileUid = String(uid || "").trim();
      if (!profileUid) {
        navigate("/", { replace: true });
        return;
      }

      try {
        const profile = await fetchUserProfileFromFirestore(profileUid);
        if (!isActive) return;

        const handle =
          normalizePublicHandle(profile?.publicHandle || "") ||
          getPublicHandle(profile?.userName || profileUid);
        if (handle) {
          navigate(`/u/${handle}`, { replace: true });
          return;
        }
      } catch (err) {
        console.error("Failed to resolve profile handle by uid:", err);
      }

      if (isActive) {
        navigate("/", { replace: true });
      }
    }

    resolveProfile();

    return () => {
      isActive = false;
    };
  }, [navigate, uid]);

  return (
    <Box sx={{ minHeight: "40vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <CircularProgress />
    </Box>
  );
}
